import React from 'react';
import PropTypes from 'prop-types';
import Headroom from 'react-headroom';
import Helmet from 'react-helmet';
import { withStyles } from '@material-ui/core/styles';

// import Theme from '../components/theme';

import withRoot from '../withRoot';
import AppBar from '../components/app-bar';
import Footer from '../components/footer';
import PoweredByStrava from '../assets/api_logo_pwrdBy_strava_horiz_gray.svg';

const styles = theme => ({
  root: {
    fontFamily: theme.typography.fontFamily,
  },
  site: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  siteMain: {
    flex: '1 0 auto',
  },
  footer: {
    flexShrink: 0,
    paddingTop: '1em',
  },
});

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.func,
  }

  render() {
    const { classes, children } = this.props;
    return (
      <div>
        <Helmet>
          <title>A Race athlete blog</title>
          <meta name="description" content="Do more with your Strava data, Search, Analyze and Plan" />
          <meta name="keywords" content="cycling, endurance, training, power, ftp, sufferscore, goals, motivation, strava" />
          <meta property="og:title" content="A Race athlete blog" />
          <meta property="og:image" content="https://blog.araceathlete.com/images/logo-512x512.png" />
          <meta property="og:url" content="https://blog.araceathlete.com" />
          <meta property="og:description" content="Do more with your Strava data, Search, Analyze and Plan" />
        </Helmet>
        <div className={classes.root}>
          <div className={classes.site} >
            <div className={classes.siteMain} >
              <Headroom>
                <AppBar
                  leftOnClick={() => {
                    if (typeof window !== `undefined`) {
                      window.location.assign('https://blog.araceathlete.com')
                    }
                  }}
                  title="A Race athlete Blog"
                />
              </Headroom>
              {children()}
            </div>
            <div className={classes.footer}>
              <Footer
                brand="rcrsv.com"
                info="This app came about because I wanted to use it. It is a labor of love and suffering, much like cycling. No longer powered by Strava."
                // imgAlt="No longer powered by Strava"
                // imgLink="https://www.strava.com"
                // imgSrc={PoweredByStrava}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRoot(withStyles(styles, { name: 'styledLayout' })(Layout));



// WEBPACK FOOTER //
// ./src/layouts/index.js